/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ApproveLedgerWithdrawRequestOptions,
  ApproveLedgerWithdrawRequestResponses,
} from '../types/ApproveLedgerWithdrawRequest'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Approve a pending withdrawal request, allowing the transfer of assets to the outside world to proceed. Note that this does not interact with any external systems; it simply updates the status of the withdrawal request in the ledger. Actual transfer of assets must be handled separately.
 * @summary Approve a pending withdrawal request
 * {@link /v1/ledger/withdraw/requests/:withdrawal_id/approve}
 */
export function approveLedgerWithdrawRequest<ThrowOnError extends boolean = true>(
  options: Options<ApproveLedgerWithdrawRequestOptions, ThrowOnError>,
): Unwrappable<RequestResult<ApproveLedgerWithdrawRequestResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/ledger/withdraw/requests/{withdrawal_id}/approve',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ApproveLedgerWithdrawRequestResponses, ThrowOnError>>,
  )
}
